<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div>
          <img style="width: 138px" src="pr.png" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Compte</strong>
    </CDropdownHeader>
    <CDropdownItem v-if="loggedIn && this.$store.state.user.role == 1">
      <CIcon name="cil-speedometer" />

      <CHeaderNavLink style="color: #605f6b" to="/home/client/dashboard">
        Dashbord
      </CHeaderNavLink>
    </CDropdownItem>

    <CDropdownItem v-if="this.$store.state.user.role == 2">
      <CIcon name="cil-speedometer" />

      <CHeaderNavLink style="color: #605f6b" to="/index">
        Dashbord
      </CHeaderNavLink>
    </CDropdownItem>

    <CDropdownItem v-if="this.$store.state.user.role == 1">
      <CIcon name="cil-envelope-open" />

      <CHeaderNavLink style="color: #605f6b" to="/chat">
        Messages
      </CHeaderNavLink>
    </CDropdownItem>

    <CDropdownItem v-if="this.$store.state.user.role == 2">
      <CIcon name="cil-envelope-open" />

      <CHeaderNavLink style="color: #605f6b" to="/chatD">
        Messages
      </CHeaderNavLink>
    </CDropdownItem>

    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Réglages</strong>
    </CDropdownHeader>

    <CDropdownItem v-if="loggedIn && this.$store.state.user.role == 1">
      <CIcon name="cil-user" />
      <CHeaderNavLink style="color: #605f6b" to="/profile/client">
        Profile
      </CHeaderNavLink>
    </CDropdownItem>

    <CDropdownItem v-if="loggedIn && this.$store.state.user.role == 2">
      <CIcon name="cil-user" />
      <CHeaderNavLink style="color: #605f6b" to="/profile/depanneur">
        Profile
      </CHeaderNavLink>
    </CDropdownItem>

    <CDropdownDivider />

    <CDropdownItem>
      <CIcon name="cil-lock-locked" />
      <router-link to="/" style="color: #496664">
        <span @click.prevent="performLogout">Se déconnecter</span>
      </router-link>
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { apiDomain } from "../config";
export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      apiDomain: "https://apil.auto-turki.com",
      token: null,
      itemsCount: 42,
      userSingll: {},
    };
  },
  computed: {
    loggedIn() {
      return this.$store.getters.get_loggedIn;
    },

    user() {
      return this.$store.getters.get_user;
    },
  },

  created() {
    /* this.fetchuserSingl(this.$store.state.user.id); */
  },
  methods: {
    performLogout() {
      this.$store
        .dispatch("performLogoutAction")
        .then((res) => {
          this.$noty.success("Déconnexion réussie.");
          this.$router.push("/");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //show user by id
    fetchuserSingl(id) {
      fetch(`${apiDomain}/api/user/${id}`)
        .then((res) => res.json())
        .then((res) => {
          this.userSingll = res.user;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>